/* eslint-disable no-nested-ternary */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import routerLoader from '../../i18n/router';
import BarCharts from './graficas/barChart';
import { AhorroObj, AhorroPorMesObj, AuthContextType } from '../../types/Types';
import { AppContextType } from '../../store/AppContext';
import 'moment/locale/eu';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ca';
import 'moment/locale/gl';
import NoData from '../../components/NoData';
import { AhorrosHelper } from './AhorrosHelper';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import { StorageHelper } from '../../utils/StorageHelper';
import PieCharts from './graficas/pieChart';
import Title from '../../components/Title';
import { IconChat } from '../../Icons';
import { HostProvider } from '../../utils/HostProvider';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import DownloadAppPopup from '../../components/DownloadAppPopup';
import { DeepLinkMappings } from '../../utils/DeepLinkMappings';
import { FrontMappings } from '../../utils/FrontMappings';
import { PriceFormatter } from '../../utils/PriceFormatter';

interface Props {
  view: boolean;
  dataUser: AuthContextType;
  ahorroCurrentMonth: number;
  getTitleText: any;
  ahorroXMes: AhorroPorMesObj[];
  ahorroDataSort: any;
  retrieveAhorrosByDate: any;
  months: any[];
  inputCurrentYear: number;
  inputCurrentMonth: number;
  isByDate: boolean;
  setIsByDate: any;
  ahorroData: AhorroObj | undefined;
  priceFormatter: any;
  pieData: any;
  ahorroTotalAnual: number;
  ahorroPotencialOroAnual: number;
  dataApp: AppContextType;
  moneda: string | undefined;
  tipoUsuarioTarjeta: number;
  saldo: number;
  totalCompras: number;
  currentMonth: number;
  puntosTravel: number;
  backError: boolean;
  currentDateCombo: any;
  setCurrentDateCombo: any;
}
const AhorrosEroski: FC<Props> = (props) => {
  const {
    view,
    dataUser,
    ahorroCurrentMonth,
    getTitleText,
    ahorroXMes,
    ahorroDataSort,
    retrieveAhorrosByDate,
    months,
    inputCurrentYear,
    inputCurrentMonth,
    isByDate,
    setIsByDate,
    ahorroData,
    priceFormatter,
    pieData,
    ahorroTotalAnual,
    ahorroPotencialOroAnual,
    dataApp,
    moneda,
    tipoUsuarioTarjeta,
    saldo,
    totalCompras,
    currentMonth,
    puntosTravel,
    backError,
    currentDateCombo,
    setCurrentDateCombo,
  } = props;
  const totalComprasProcessed = PriceFormatter.formatStringAsPrice(
    totalCompras?.toString(),
  );
  const { t } = useTranslation();
  const isEroski = HostProvider.isEroski();
  const isApp = dataUser.user.isApp === 'true';

  const [linkSaldo, setLinkSaldo] = useState('');
  const [linkTickets, setLinkTickets] = useState('');
  const [linkTravel, setLinkTravel] = useState('');

  const arFrontMap = [
    FrontMappings.SALDO,
    FrontMappings.COMPRAS,
    FrontMappings.PUNTOS_TRAVEL,
  ];
  const arDeepMap = [
    DeepLinkMappings.linkSaldo,
    DeepLinkMappings.linkTickets,
    DeepLinkMappings.linkTravel,
  ];

  const getUrls = async () => {
    const resUrlODeepLink = await AhorrosHelper.getUrlDeepLink(
      arFrontMap,
      arDeepMap,
      dataApp.lang,
      isApp,
      !isEroski,
    );

    let urlSaldo;
    let urlTickets;
    let urlTravel;

    // eslint-disable-next-line prefer-const
    [urlSaldo, urlTickets, urlTravel] = resUrlODeepLink;

    setLinkSaldo(urlSaldo);
    setLinkTravel(urlTravel);
    setLinkTickets(urlTickets);
  };

  useEffect(() => {
    if (dataUser.user.token !== '' || !isApp) getUrls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token, dataApp.lang]);

  return (
    <>
      <BotonVolverFlotante />
      {(() => {
        const isEcommerceBot = StorageHelper.isEcommerceBot();
        StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
        return (
          <>
            <section className="o-section--medium o-section--no-padding-top  section--background">
              <div className="container">
                <div className="cabecera-seccion">
                  <Title
                    titleName={t('ahorros.title')}
                    titleValue={ahorroCurrentMonth}
                    numText={getTitleText()}
                    page="ahorros"
                    isLoad={view}
                  />
                </div>
              </div>
            </section>
            {(() => {
              if (
                view &&
                ahorroXMes &&
                ahorroXMes.length > 0 &&
                ahorroDataSort
              ) {
                return (
                  <>
                    <section className="o-section--large MisAhorros">
                      <div className="container">
                        <div className="row">
                          <div className="col-12 col-sm-4">
                            <form
                              autoComplete="off"
                              className="u-display-flex u-margin-bottom-large"
                              method="post"
                            >
                              <div className="form-group u-margin-right-medium">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  htmlFor="datepicker-mes"
                                  className="control-label"
                                >
                                  {t('ahorros.fecha')}
                                </label>

                                <div className="form-control-block has-icon">
                                  <select
                                    className="form-control"
                                    id="fecha"
                                    onChange={(periodo) => {
                                      setCurrentDateCombo(
                                        Number(periodo.target.value),
                                      );
                                      retrieveAhorrosByDate(
                                        periodo.target.value,
                                      );
                                    }}
                                  >
                                    {months.length > 0 &&
                                      months.map((date) => (
                                        <option
                                          key={date.periodo}
                                          value={date.periodo}
                                          selected={
                                            date.periodo === currentDateCombo
                                          }
                                        >
                                          {date.month} {date.year}
                                        </option>
                                      ))}{' '}
                                  </select>
                                  <div className="icon icon-small">
                                    <IconChat />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>

                        <h2 className="titulo-pagina u-margin-bottom-large">
                          {t('ahorros.evolucion')}
                        </h2>

                        {(() => {
                          if (ahorroXMes !== null) {
                            return (
                              <div className="wrapper barras u-margin-bottom">
                                <BarCharts
                                  data={ahorroXMes}
                                  periodo={{
                                    year: inputCurrentYear,
                                    month: inputCurrentMonth,
                                  }}
                                  reload={isByDate}
                                  setReload={setIsByDate}
                                />{' '}
                              </div>
                            );
                          }
                          return false;
                        })()}

                        {(() => {
                          if (
                            ahorroData !== null &&
                            ahorroData !== undefined &&
                            ahorroData.ahorroTotal !== undefined
                          ) {
                            return (
                              <div className="row">
                                <div className="col-12 col-sm-6">
                                  <div className="table-responsive">
                                    <table className="table table--striped">
                                      <thead>
                                        <tr>
                                          <th>{t('ahorros.concepto')}</th>
                                          <th className="num">
                                            {t('ahorros.importe')}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <p className="u-font-bold">
                                              {t('ahorros.por-socio')}
                                            </p>
                                          </td>
                                          <td className="num">
                                            <span className="ok">
                                              {ahorroData &&
                                              ahorroData.ahorroPertenenciaClub <
                                                0
                                                ? t('ahorros.no-disponible')
                                                : ahorroData &&
                                                  ahorroData.ahorroPertenenciaClub >=
                                                    0
                                                ? priceFormatter(
                                                    ahorroData.ahorroPertenenciaClub,
                                                  )
                                                : 0}
                                            </span>
                                          </td>
                                        </tr>
                                        {ahorroDataSort.map((ahorro) => (
                                          <tr>
                                            <td>
                                              <p>
                                                {t(
                                                  `ahorros.${AhorrosHelper.getRowName(
                                                    ahorro.key,
                                                  )}`,
                                                )}
                                              </p>
                                            </td>
                                            <td className="num">
                                              <span>
                                                {ahorro.val < 0
                                                  ? t('ahorros.no-disponible')
                                                  : ahorro.val > 0
                                                  ? priceFormatter(ahorro.val)
                                                  : 0}
                                              </span>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td>
                                            <p className="u-font-bold">
                                              {t('ahorros.ofertas-masivas')}
                                            </p>
                                          </td>
                                          <td className="num">
                                            <span className="ok">
                                              {ahorroData &&
                                              ahorroData.ahorroOfertaMasiva < 0
                                                ? t('ahorros.no-disponible')
                                                : priceFormatter(
                                                    ahorroData.ahorroOfertaMasiva,
                                                  )}
                                            </span>
                                          </td>
                                        </tr>
                                        {ahorroData.ahorroPuntosTravel &&
                                        ahorroData.ahorroPuntosTravel > 0 ? (
                                          <tr>
                                            <td>
                                              <p className="u-font-bold">
                                                {t('ahorros.canjeo-puntos')}
                                              </p>
                                            </td>
                                            <td className="num">
                                              <span className="ok">
                                                {priceFormatter(
                                                  ahorroData.ahorroPuntosTravel,
                                                )}
                                              </span>
                                            </td>
                                          </tr>
                                        ) : (
                                          ''
                                        )}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td>
                                            <p>{t('ahorros.ahorro-total')}</p>
                                          </td>
                                          <td className="num">
                                            <p className="bloque-datos__ahorro">
                                              {ahorroData &&
                                              ahorroData.ahorroTotal < 0
                                                ? t('ahorros.no-disponible')
                                                : ahorroData &&
                                                  ahorroData.ahorroTotal >= 0
                                                ? priceFormatter(
                                                    ahorroData.ahorroTotal,
                                                  )
                                                : 0}
                                            </p>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                </div>

                                <div className="col-sm-6 col-xs-12 pie-container">
                                  <div className="wrapper">
                                    <PieCharts
                                      data={pieData}
                                      conceptoSocio={
                                        ahorroData.ahorroPertenenciaClub
                                      }
                                      conceptoOfertas={
                                        ahorroData.ahorroOfertaMasiva
                                      }
                                      conceptoPuntosTravel={
                                        ahorroData.ahorroPuntosTravel
                                      }
                                    />{' '}
                                  </div>
                                  <div id="custom-legend">
                                    <ul className="0-legend">
                                      {ahorroData &&
                                      ahorroData.ahorroPertenenciaClub > 0 ? (
                                        <li>
                                          <span className="li1" />
                                          {t('ahorros.por-socio')}
                                        </li>
                                      ) : (
                                        ''
                                      )}
                                      {ahorroData &&
                                      ahorroData.ahorroOfertaMasiva > 0 ? (
                                        <li>
                                          <span className="li2" />
                                          {t('ahorros.por-ofertas')}
                                        </li>
                                      ) : (
                                        ''
                                      )}
                                      {ahorroData &&
                                      ahorroData.ahorroPuntosTravel > 0 ? (
                                        <li>
                                          <span className="li3" />
                                          {t('ahorros.canjeo-puntos')}
                                        </li>
                                      ) : (
                                        ''
                                      )}
                                    </ul>
                                  </div>{' '}
                                </div>
                              </div>
                            );
                          }
                          return (
                            <NoData>
                              <div className="mensaje">
                                <p>{t('travel.noRecords')}</p>
                              </div>
                            </NoData>
                          );
                        })()}

                        <div className="divider" />
                        {(() => {
                          if (
                            ahorroTotalAnual > 0 ||
                            ahorroPotencialOroAnual > 0
                          ) {
                            return (
                              <>
                                <div className="u-display-flex-desktop">
                                  {(() => {
                                    if (
                                      ahorroTotalAnual &&
                                      ahorroTotalAnual > 0
                                    ) {
                                      return (
                                        <div className="bloque-datos u-margin-right-giant u-margin-bottom">
                                          <p className="bloque-datos__title u-margin-bottom-tiny">
                                            <span className="u-margin-right">
                                              {t('ahorros.tu-ahorro')}{' '}
                                            </span>
                                          </p>
                                          {dataApp.lang === 'eu' ? (
                                            <>
                                              <p className="u-margin-bottom-small">
                                                {moment(
                                                  inputCurrentYear,
                                                  'YYYY',
                                                )
                                                  .locale(dataApp.lang)
                                                  .format('YYYY')}
                                                {t('ahorros.de-anno')}{' '}
                                                {moment(inputCurrentMonth, 'MM')
                                                  .locale(dataApp.lang)
                                                  .format('MMMM')}{' '}
                                                {t('ahorros.hasta')}...
                                              </p>
                                              <p className="bloque-datos__ahorro u-text-ok">
                                                {priceFormatter(
                                                  ahorroTotalAnual,
                                                )}{' '}
                                                <sup>
                                                  {moneda === 'euro'
                                                    ? t('euro')
                                                    : t('cc')}
                                                </sup>
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p className="u-margin-bottom-small">
                                                {t('ahorros.hasta')}{' '}
                                                {moment(inputCurrentMonth, 'MM')
                                                  .locale(dataApp.lang)
                                                  .format('MMMM')}{' '}
                                                {t('ahorros.de-anno')}{' '}
                                                {moment(
                                                  inputCurrentYear,
                                                  'YYYY',
                                                )
                                                  .locale(dataApp.lang)
                                                  .format('YYYY')}
                                                ...
                                              </p>
                                              <p className="bloque-datos__ahorro u-text-ok">
                                                {priceFormatter(
                                                  ahorroTotalAnual,
                                                )}{' '}
                                                <sup>
                                                  {moneda === 'euro'
                                                    ? t('euro')
                                                    : t('cc')}
                                                </sup>
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      );
                                    }
                                    return <></>;
                                  })()}
                                  {(() => {
                                    if (
                                      ahorroPotencialOroAnual &&
                                      ahorroPotencialOroAnual >= 5 &&
                                      tipoUsuarioTarjeta > -1 &&
                                      tipoUsuarioTarjeta !== 4 &&
                                      tipoUsuarioTarjeta !== 5
                                    ) {
                                      return (
                                        <div className="bloque-datos">
                                          <p className="bloque-datos__title u-margin-bottom-tiny">
                                            <span className="u-margin-right">
                                              {t('ahorros.tarjeta-oro')}
                                            </span>
                                          </p>
                                          {dataApp.lang === 'eu' ? (
                                            <>
                                              <p className="u-margin-bottom-small">
                                                {moment(
                                                  inputCurrentYear,
                                                  'YYYY',
                                                )
                                                  .locale(dataApp.lang)
                                                  .format('YYYY')}
                                                {t('ahorros.de-anno')}{' '}
                                                {moment(inputCurrentMonth, 'MM')
                                                  .locale(dataApp.lang)
                                                  .format('MMMM')}{' '}
                                                {t('ahorros.hasta')}
                                                {', '}
                                                {t('ahorros.hubieras-ahorrado')}
                                                ...
                                              </p>
                                              <p className="bloque-datos__ahorro u-text-oro">
                                                +{' '}
                                                {priceFormatter(
                                                  ahorroPotencialOroAnual,
                                                )}{' '}
                                                <sup>
                                                  {moneda === 'euro'
                                                    ? t('euro')
                                                    : t('cc')}
                                                </sup>
                                              </p>
                                            </>
                                          ) : (
                                            <>
                                              <p className="u-margin-bottom-small">
                                                {t('ahorros.hubieras-ahorrado')}{' '}
                                                {moment(inputCurrentMonth, 'MM')
                                                  .locale(dataApp.lang)
                                                  .format('MMMM')}{' '}
                                                {t('ahorros.de-anno')}{' '}
                                                {moment(
                                                  inputCurrentYear,
                                                  'YYYY',
                                                )
                                                  .locale(dataApp.lang)
                                                  .format('YYYY')}
                                                ...
                                              </p>
                                              <p className="bloque-datos__ahorro u-text-oro">
                                                +{' '}
                                                {priceFormatter(
                                                  ahorroPotencialOroAnual,
                                                )}{' '}
                                                <sup>
                                                  {moneda === 'euro'
                                                    ? t('euro')
                                                    : t('cc')}
                                                </sup>
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      );
                                    }
                                    return <></>;
                                  })()}
                                </div>

                                <div className="divider" />
                              </>
                            );
                          }
                          return <></>;
                        })()}
                      </div>
                    </section>
                    <section className="o-section MisAhorros">
                      <div className="container">
                        <h2 className="titulo-pagina u-margin-bottom-large">
                          {t('ahorros.puedes-consultar-tambien')}
                        </h2>
                        <div className="listado-ventajas u-margin-bottom-giant">
                          <div className="row">
                            {saldo !== null
                              ? AhorrosHelper.ventajasSaldoApp(
                                  moneda,
                                  linkSaldo,
                                  priceFormatter(saldo),
                                  t,
                                )
                              : ''}
                            {totalCompras != null
                              ? AhorrosHelper.ventajasComprasWeb(
                                  routerLoader.LoadRouterByPath(
                                    linkTickets,
                                    dataApp.lang,
                                  ),
                                  moneda,
                                  totalComprasProcessed,
                                  moment()
                                    .month(currentMonth - 1)
                                    .locale(dataApp.lang)
                                    .format('MMMM'),
                                  t,
                                )
                              : ''}
                            {puntosTravel !== null
                              ? AhorrosHelper.ventajasPuntosTravelApp(
                                  linkTravel,
                                  priceFormatter(puntosTravel),
                                  t,
                                )
                              : ''}
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                );
              }
              return (
                <NoData>
                  <div className="container-inner__small">
                    {(() => {
                      if (backError) {
                        return (
                          <>
                            <div className="mensaje">
                              <p>{t('ahorros.no-records')}</p>
                              <p>{t('ahorros.no-records2')}</p>
                            </div>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <div className="mensaje">
                              <p>{t('ahorros.no-records-yet')}</p>
                            </div>
                          </>
                        );
                      }
                    })()}
                  </div>
                </NoData>
              );
            })()}
            <DownloadAppPopup page="ahorros" />
          </>
        );
      })()}
    </>
  );
};

export default AhorrosEroski;
